// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import login from './components/login/login.vue';
import register from './components/register/register.vue';
import findPas from './components/findPas/findPas.vue';
import third from './components/third/third.vue';
import './css/reset.css';
import './js/geetest.js';

Vue.use(VueRouter);
Vue.use(VueResource);
Vue.http.options.emulateJSON = true;

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: process.env.BASE + 'login', name: 'login', component: login },
    { path: process.env.BASE + 'index.html', name: 'login', component: login },
    { path: process.env.BASE + 'register', name: 'register', component: register },
    { path: process.env.BASE + 'findPas', name: 'findPas', component: findPas },
    { path: process.env.BASE + 'third', name: 'third', component: third },
    { path: process.env.BASE + '*', redirect: process.env.BASE + 'index.html' }
  ],
  linkActiveClass: 'active'
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js